// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/triggerSyncMutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps($connection_id: uuid!, $location_id: uuid!) {
  apps_sync_processing_start(
    connection_id: $connection_id
    location_id: $location_id
  ) {
    ok
    sync_id
  }
}

`